import { pickAll, head } from 'ramda';
import { clientName, HttpClient, JSON_STRING, MHTTPCL } from '../../../services/http/http-client';
import { overviewService } from './booking-details/booking-overview.service';
import { moneyDetailsService } from './booking-details/money-details.service';
import { bookingDocumentService } from './booking-details/documents.service';
import { eventDetailsService, CALENDAR_DATE_ARTISTS } from './booking-details/event-details.service';
import { customChecklistService } from './booking-details/custom-checklist.service';
import { travelDetailsService } from './booking-details/travel-details.service';
import { localDetailsService } from './booking-details/local-details.service';
import { createCalendarDateArtist } from '../models/calendar-date-artist.model';
import { accountingURL } from '../../accounting/services/invoices.service';
import { bookingRequestsService } from './booking-requests.service';
import { bookingTemplatesService } from './booking-templates.service';
import { ArtistService } from './artists';
import { bookingPromotersService } from './booking-promoters.service';
import { bookingReportsService } from './booking-reports.service';

export const MODIFICATION_URL = '/modify.pl';

export const BOOKING_URL = '/booking.pl';
export const SETTINGS_URL = '/settings.pl';
export const ACCOUNTING_URL = '/accounting.pl';
export const CONTACTS_URL = '/contacts.pl';
export const TRAVEL_URL = '/travel.pl';
export const BOOKINGS_STRING = 'bookings';

export const CALENDAR_DATE_ID = 'calendar_date_id';

export const CALENDAR_DATES_STRING = 'calendar_dates';

const CALENDAR_BOOKINGS_OVERVIEW = 'calendar_bookings_overview';
const JSON_OUTPUT = 'json';

const BOOKING_CAL_CUST_CHECKLIST = 'booking_calendar_custom_checklist_form';
const NAME_PER_SECTION_JSON = 'names_per_section_json';
const CAL_DATES = 'calendar_dates';

const BCAL_TASK_CHECKLIST_SEARCH =
  'booking_calendar_task_checklist_item_search';

const DELETE_RELATION = 'delete_relation';
const SEARCH_MODAL_CONTACTS = 'search_modal_contacts';
const INDIVIDUAL = 'individual';
const EMPTY_STRING = '';
const SET_CONTACT_RELATIONS = 'set_contact_relations';
const CALENDAR_DATES = 'calendar_dates';
const SMALL_LOCAL_DETAILS = 'small_local_details';
const INDIVIDUAL_CONTACT_FORM = 'individual_contact_form';
const SAVE_INDIVIDUAL_CONTACT_RT_IND_LST = 'save_individual_contact_n_retrieve_individual_list';
const CALENDAR_BOOKINGS_NEW_DEALS = 'calendar_bookings_new_deals';
const CALENDAR_BOOKINGS_INVOICE_LINES = 'calendar_bookings_invoice_lines';
const GET_PROMOTER_INTERFACE = 'get_promoter_interface';
const SEND_PERMISSION_MAIL_ON_SIGNING_CONTRACT = 'send_permission_mail_on_signing_contract';
const ARTIST_DETAILS = 'artist_details';
const RECORD_STRING = 'record';
const UNRELATED_ARTISTS = 'unrelated_artists';
const SEARCH_UNRELATED_ARTISTS = 'search_unrelated_artists';
const ADD_ARTISTS = 'add_artists';
const ADD_REMOVE_STRING = 'add_remove_artist';
const LOAD_ARTISTS = 'load_artists';
const BOOKING_CALENDAR_TASK_CHECKLIST_FORM = 'booking_calendar_task_checklist_form';
const NAME_STRING = 'name';
const CHECKLIST_STRING = 'checklist';
const GROUP_NAME = 'group_name';
const ASSIGNED_TO_USER = 'assigned_to_user';
const BOOKING_CALENDAR_TASK_CHECKLIST_ITEM_ADD = 'booking_calendar_task_checklist_item_add';
const BOOKING_CALENDAR_TASK_CHECKLIST_ITEM_SEARCH = 'booking_calendar_task_checklist_item_search';
const BOOKING_CALENDAR_TASK_CHECKLIST_ITEM_ASSIGN_TO_USER = 'booking_calendar_task_checklist_item_assign_to_user';
const REMOVE_ASSIGN = 'remove_assign';
const GROUPS = 'groups';
const BOOKING_CALENDAR_TASK_CHECKLIST_ITEM_GROUP_DELETE = 'booking_calendar_task_checklist_item_group_delete';
const BOOKING_CALENDAR_TASK_CHECKLIST_ITEM_DELETE = 'booking_calendar_task_checklist_item_delete';
const ITEMS = 'items';
const PRICE = 'price';
const INVOICELINES = 'invoicelines';

const TEXT = 'text';
const CALENDAR_BOOKINGS_DEALS_ADD_INVOICELINES_FORM = 'calendar_bookings_deals_add_invoicelines_form';
const BOOKING_DEALS_INVOICE_PROJECTS = 'booking_deals_invoice_projects';
const BOOKING_DEALS_CREATE_INVOICE = 'booking_deals_create_invoice';
const INVOICES_STRING = 'invoices';
const DISPLAY_PAYPAL_PAYMENT_MSG_MODAL = 'displayPaypalPaymentMsgModal';
const INVOICE_REMAINDER = 'invoice_reminder';
const EMAIL_INVOICE_DETAILS = 'emailInvoiceDetails';
const COUNTRIES_OF_CITY = 'countries_of_city';
const GET_VENUE_CONTEXT = 'get_venue_context';
const BOOKING_LOCATION_ID = 'booking_location_id';
const BOOKING_LOCATIONS = 'booking_locations';
const BOOKING_PL = 'booking.pl';
const BOOKING_WIZARD_SEARCH_PROMOTER = 'booking_wizard_search_promoter';
const PROMOTER_TABLE1 = 'promoter_table1';
const PROMOTER_SEARCH_STATUS = 'promoter_search_status';
const BOOKING_WIZARD_CHCK_CONTACT_IS_PROMOTER = 'booking_wizard_check_contact_is_promoter';
const CONTACT_ID = 'contact_id';
const CONTACTS = 'contacts';
const BOOKING_WIZARD = 'booking_wizard';
const BOOKING_WIZARD_SEARCH_ARTIST = 'booking_wizard_search_artist';
const ARTIST_TABLE = 'artist_table';
const ARTIST_SEARCH_STATUS = 'artist_search_status';
const NEXT_BOOKING_WIZARD_STEP_1 = 'next_booking_wizard_step_1';
const BOOKING_WIZARD_SEARCH_VENUE = 'booking_wizard_search_venue';
const VENUE_TABLE = 'venue_table';
const VENUE_SEARCH_STATUS = 'venue_search_status';
const VERIFY_PROMOTER = 'verify_promoter';
const LINK_CONTACT_TO_PROMOTER = 'link_contact_to_promoter';
const NEXT_BOOKING_WIZARD_STEP_3 = 'next_booking_wizard_step_3';
const BOOKING_WIZARD_SEARCH_CONTACT = 'booking_wizard_search_contact';
const CONTACT_TABLE = 'contact_table';
const CONTACT_SEARCH_STATUS = 'contact_search_status';
const TASK_DONE = 'task_done';
const TASK_DONE_UNDO = 'task_done_undo';
const TEMPLATES_STRING = 'templates';
const REQUEST_FORM_MAIL = 'request_form_mail';
const BOOKING_REQUEST_HOSTED_URL = clientName => `http://app.details.eu/request/${clientName}/ext_request.pl?action=hosted`;
const RENDER_STRING = 'render';
const MONTHLY_CALENDAR_DATES = 'monthly_external_dates';
export const BookingService = {
  //   action: booking_artist_info
  // calendar_date_artist_id: 13588
  // section: bookings

  contactsAgreedSign: (key, kVal, name, value, table, modified) => MHTTPCL.post(MODIFICATION_URL, {
    key: key,
    kVal: kVal,
    name: name,
    value: value,
    table: table,
    modified: modified
  }

  ),
  updateContractsPromoterInfo: (contracts_out_flag, contracts_sent_date, calendar_date_id) => MHTTPCL.post(BOOKING_URL, {
    action: "update_contracts_promoter_info",
    section: "bookings",
    contracts_out_flag: contracts_out_flag,
    contracts_sent_date: contracts_sent_date,
    calendar_date_id: calendar_date_id

  })

  ,

  bookingArtistInfo: (calendarDateArtistId) => HttpClient.post(BOOKING_URL, {
    section: 'bookings',
    action: 'booking_artist_info',
    calendar_date_artist_id: calendarDateArtistId,
  }),
  loadDefaults: (calendarDateArtistId) => HttpClient.post(BOOKING_URL, {
    section: 'bookings',
    action: 'load_set_booking_artist_default_own',
    calendar_date_artist_id: calendarDateArtistId,
  }),
  findAll: () => {
    return HttpClient.get(BOOKING_URL, {
      booking_month: '201806',
      output: 'json',
      artist: '*',
      status: '[]',
      staff_id: '',
      txt: '',
      status_c: '',
      status_r: '',
      status_l: '',
      status_t: '',
      status_i: '',
      status_exclusivity: '',
      section: 'booking',
      action: 'booking_list',
    });
  },
  findBookingArtistList: ({
    booking_month = '',
    artist = '*',
    status = '[]',
    staff_id = '',
    txt = '',
    status_c = '',
    status_r = '',
    status_l = '',
    status_t = '',
    status_i = '',
    status_exclusivity = '',
    startrow = 0,
    sort = ''
  } = {}, options) => {
    if (booking_month == '' &&
      artist == '*' &&
      status == '[]' &&
      staff_id == ''
    ) {
      booking_month = ''
    }

    return HttpClient.post(BOOKING_URL, {
      booking_month,
      artist,
      status,
      staff_id,
      txt,
      status_c,
      status_r,
      status_l,
      status_t,
      status_i,
      status_exclusivity,
      sort,
      section: 'booking',
      action: 'booking_list',
      ...(startrow > 0 ? {
        startrow: startrow,
      } : {}),
      // no_limit: 1
    }, options);
  },
  findBookingModuleInfo: () => HttpClient.get2(BOOKING_URL, {
    section: 'booking'
  }),
  findBookingOverview: (calendarDateId, options) => {
    return HttpClient.get(BOOKING_URL, {
      section: BOOKINGS_STRING,
      action: CALENDAR_BOOKINGS_OVERVIEW,
      calendar_date_id: calendarDateId,
      output: JSON_OUTPUT,
    }, options);
  },
  findBookingOverviewInvoices: (calendarDateId, options) => {
    return HttpClient.get(BOOKING_URL, {
      section: BOOKINGS_STRING,
      action: 'calendar_bookings_overview_invoices',
      calendar_date_id: calendarDateId
    }, options);
  },
  findBookingTaskList: ({calendar_date_id, search}, options) => {
    return HttpClient.get(BOOKING_URL, {
      section: BOOKINGS_STRING,
      action: 'calendar_bookings_task_list',
      calendar_date_id,
      search: search ?? "",
    }, options);
  },
  addBookingTaskFromPreviousTask: (params, options) => {
    return HttpClient.post(BOOKING_URL, {
      section: BOOKINGS_STRING,
      action: 'calendar_bookings_task_list_add_from_prev',
      ...params
    }, options);
  },
  addBookingTaskListItemManually: (params, options) => {
    return HttpClient.post(BOOKING_URL, {
      section: BOOKINGS_STRING,
      action: 'calendar_bookings_task_list_add_item_manually',
      ...params
    }, options);
  },
  removeTaskListItem: (task_id, options) => {
    return HttpClient.post(BOOKING_URL, {
      section: BOOKINGS_STRING,
      action: 'calendar_bookings_task_list_delete_item',
      task_id
    }, options);
  },
  modifyTaskListItem: ({
    value,
    name,
    item
  }) => {
    return HttpClient.post(MODIFICATION_URL, {
      kVal: item.task_id,
      name,
      value,
      table: 'tasks_user'
    })
  },
  findCustomChecklist: (calendarDateId, options) => {
    return HttpClient.get(BOOKING_URL, {
      action: BOOKING_CAL_CUST_CHECKLIST,
      section: BOOKINGS_STRING,
      section_db: BOOKINGS_STRING,
      action_perform: NAME_PER_SECTION_JSON,
      external_table: CAL_DATES,
      external_id: calendarDateId,
      output: JSON_OUTPUT,
    }, options);
  },
  findCalendarTaskChecklistItem: (userId, calendarDateId, options) => {
    return HttpClient.get2(BOOKING_URL, {
      item_type: ASSIGNED_TO_USER,
      section_checklist: BOOKINGS_STRING,
      user_id: userId,
      external_table: CAL_DATES,
      external_id: calendarDateId,
      action: BCAL_TASK_CHECKLIST_SEARCH,
      section: BOOKINGS_STRING,
    }, options);
  },

  // Contact Relation Http Calls

  deleteContactRelation: (
    contactRelationId
  ) => HttpClient.post(CONTACTS_URL, {
    action: DELETE_RELATION,
    contact_relation_id: contactRelationId
  }
  ),

  findContacts: (
    searchString = EMPTY_STRING,
    contactSearchType = INDIVIDUAL
  ) => HttpClient.get2(CONTACTS_URL, {
    action: SEARCH_MODAL_CONTACTS,
    search_str: searchString,
    contact_search_type: contactSearchType
  }
  ),
  findContactGroups: () => HttpClient.get2(CONTACTS_URL, {
    action: INDIVIDUAL_CONTACT_FORM,
    makerelation: 1
  }),

  insertContact: (
    first_name,
    last_name,
    email1,
    phone1,
    group_id1,
    group_id2,
    group_id3,
  ) => HttpClient.post(CONTACTS_URL, {
    action: SAVE_INDIVIDUAL_CONTACT_RT_IND_LST,
    first_name,
    last_name,
    email1,
    phone1,
    group_id1,
    group_id2,
    group_id3,
  }),


  // The API has a mistake. 
  // Contact ID and External ID is switched

  createContactRelation: (
    contactId,
    calendarDateId
  ) => HttpClient.post(CONTACTS_URL, {
    action: SET_CONTACT_RELATIONS,
    contact_id: calendarDateId,
    external_id: contactId,
    external_table: CALENDAR_DATES,
    external_id2: EMPTY_STRING,
    external_table2: EMPTY_STRING,
    template_type: SMALL_LOCAL_DETAILS,
    contact_search_type: INDIVIDUAL
  }),



  // Send Documents and Files

  findSendDocumentFiles: (
    calendarDateId
  ) => HttpClient.get2(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: 'booking_documents_send_out',
    calendar_date_id: calendarDateId,
  }),

  insertSendDocumentFiles: (
    calendar_date_id,
    document_id,
    invoice_id,
    file_relation_id,
  ) => HttpClient.post(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: 'document_invoice_files_send_mail',
    calendar_date_id: calendar_date_id,
    document_id: document_id,
    invoice_id: invoice_id,
    file_relation_id: file_relation_id,
  }),

  findInvoiceItemGroups: ({
    calendarDateId,
    options
  }) => HttpClient.post(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: CALENDAR_BOOKINGS_NEW_DEALS,
    calendar_date_id: calendarDateId,
    output: JSON_STRING
  }, options),

  insertInvoiceLineItemGroup: (
    groupName,
    calendarDateId
  ) => HttpClient.post(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: CALENDAR_BOOKINGS_INVOICE_LINES,
    group_name: groupName,
    calendar_date_id: calendarDateId,
    output: JSON_STRING
  }),

  insertInvoiceLineItem: ({
    invoiceItemId,
    calendarDateId
  }) => HttpClient.post(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: CALENDAR_BOOKINGS_INVOICE_LINES,
    invoice_item_id: invoiceItemId,
    calendar_date_id: calendarDateId,
    output: JSON_STRING
  }),


  // Promoter Interface

  findPromoterInterface: (
    contactIdPromoter
  ) => HttpClient.post(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: GET_PROMOTER_INTERFACE,
    contact_id_promoter: contactIdPromoter
  }),

  // Send Promoter Permission Mail

  sendPromoterMail: (
    promoterId,
    email,
    displayName,
    emailBody,
    subject,
    documentId,
    contactIdPromoter
  ) => HttpClient.post(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: SEND_PERMISSION_MAIL_ON_SIGNING_CONTRACT,
    promoter_id: promoterId,
    email: email,
    display_name: displayName,
    emailbody: emailBody,
    subject: subject,
    document_id: documentId,
    contact_id_promoter: contactIdPromoter
  }),

  //https://staging.detailsdetails.eu/berlin3/booking.pl?
  // section=bookings&
  // action=artist_details&
  // calendar_date_artist_id=12469&
  // calendar_date_id=3588&
  // date=&
  // rndval=1544701498743&
  // output=json0

  findArtistDetails: ({
    calendarDateArtistId,
    calendarDateId,
    date = ''
  }) => HttpClient.get(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: ARTIST_DETAILS,
    calendar_date_artist_id: calendarDateArtistId,
    calendar_date_id: calendarDateId,
    date: date,
  }),

  modifyCalendarDateArtist: ({
    calendarDateArtist = createCalendarDateArtist()
  }) => HttpClient.post(MODIFICATION_URL, {
    modify_type: RECORD_STRING,
    table: CALENDAR_DATE_ARTISTS,
    kVal: calendarDateArtist.calendar_date_artist_id,
    ...pickAll(modifyCaledarArtistKeys, calendarDateArtist)
  }),

  findArtistsList: ({
    calendarDateId,
    calendarDate
  }) => HttpClient.get(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: UNRELATED_ARTISTS,
    calendar_date_id: calendarDateId,
    date: calendarDate,
  }),
  findArtistsByName: ({
    calendarDateId,
    search
  }) => HttpClient.get(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: SEARCH_UNRELATED_ARTISTS,
    calendar_date_id: calendarDateId,
    search,
  }),
  addArtists: ({
    calendarDateId,
    calendarDate,
    artists
  }) => HttpClient.post(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: ADD_ARTISTS,
    output: JSON_STRING,
    calendar_date_id: calendarDateId,
    date: calendarDate,
    artists
  }),
  loadArtist: ({
    calendarDateId,
  }) => HttpClient.post(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: LOAD_ARTISTS,
    output: JSON_STRING,
    calendar_date_id: calendarDateId,
  }),
  removeArtist: ({
    calendarDateId,
    artistId
  }) => HttpClient.post(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: ADD_REMOVE_STRING,
    calendar_date_id: calendarDateId,
    artist_id: artistId
  }),
  removeArtistExclusivity: (cdaID) => HttpClient.post(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: "artist_exclusivity_remove",
    calendar_date_artist_id: cdaID
  }),

  findTaskChecklistForm: ({
    calendarDateId
  }) => HttpClient.get(BOOKING_URL, {
    action: BOOKING_CALENDAR_TASK_CHECKLIST_FORM,
    section: BOOKINGS_STRING,
    section_db: BOOKINGS_STRING,
    external_id: calendarDateId,
    external_table: CALENDAR_DATES,
  }),
  modifyChecklistItemName: ({
    checklistId,
    name
  }) => {
    return HttpClient.post(MODIFICATION_URL, {
      kVal: checklistId,
      name: NAME_STRING,
      value: name,
      table: CHECKLIST_STRING
    })
  },
  modifyChecklistGroupName: ({
    oldName,
    newName
  }) => HttpClient.post(MODIFICATION_URL, {
    table: CHECKLIST_STRING,
    name: GROUP_NAME,
    modified: BOOKINGS_STRING,
    kVal: oldName,
    value: newName,
  }),
  findChecklistItemByAssignedUser: ({
    userId,
    calendarDateId
  }) => HttpClient.post(BOOKING_URL, {
    item_type: ASSIGNED_TO_USER,
    section_checklist: BOOKINGS_STRING,
    user_id: userId,
    action: BOOKING_CALENDAR_TASK_CHECKLIST_ITEM_SEARCH,
    section: BOOKINGS_STRING,
    external_id: calendarDateId,
    external_table: CALENDAR_DATES
  }),
  findChecklistItemByName: ({
    name
  }) => HttpClient.get(BOOKING_URL, {
    action: BOOKING_CALENDAR_TASK_CHECKLIST_ITEM_SEARCH,
    section: BOOKINGS_STRING,
    section_checklist: BOOKINGS_STRING,
    name
  }),
  removeUserAssingedTasks: ({
    calendarDateId,
    userId
  }) => HttpClient.post(BOOKING_URL, {
    action: BOOKING_CALENDAR_TASK_CHECKLIST_ITEM_ASSIGN_TO_USER,
    section: BOOKINGS_STRING,
    section_checklist: BOOKINGS_STRING,
    from: REMOVE_ASSIGN,
    external_table: CALENDAR_DATES,
    external_id: calendarDateId,
    user_id: userId
  }),
  assignToUser: ({
    userId,
    calendarDateId,
    from = GROUPS || ITEMS,
    items = '[]',
    selectedGroups = '[]',
    groupName = ''
  }) => HttpClient.post(BOOKING_URL, {
    from,
    section: BOOKINGS_STRING,
    action: BOOKING_CALENDAR_TASK_CHECKLIST_ITEM_ASSIGN_TO_USER,
    items,
    selected_groups: selectedGroups,
    group_name: groupName,
    user_id: userId,
    section_checklist: BOOKINGS_STRING,
    external_table: CALENDAR_DATES,
    external_id: calendarDateId
  }),
  assignAITask: ({
    calendarDateId,
    task,
    checklist_id
  }) => HttpClient.post(BOOKING_URL, {
    from: 'assign_ai_task',
    section: BOOKINGS_STRING,
    action: BOOKING_CALENDAR_TASK_CHECKLIST_ITEM_ASSIGN_TO_USER,
    task,
    section_checklist: BOOKINGS_STRING,
    external_table: CALENDAR_DATES,
    external_id: calendarDateId,
    checklist_id
  }),
  addNewChecklistItem: ({
    name
  }) => HttpClient.post(BOOKING_URL, {
    action: BOOKING_CALENDAR_TASK_CHECKLIST_ITEM_ADD,
    section: BOOKINGS_STRING,
    section_checklist: BOOKINGS_STRING,
    name
  }),
  completeTask: ({
    calendarDateId,
    checklistId,
    taskName
  }) => HttpClient.get(BOOKING_URL, {
    section_checklist: BOOKINGS_STRING,
    external_table: CALENDAR_DATES,
    external_id: calendarDateId,
    action: BOOKING_CALENDAR_TASK_CHECKLIST_ITEM_ASSIGN_TO_USER,
    section: BOOKINGS_STRING,
    checklist_id: checklistId,
    from: TASK_DONE,
    task_name: taskName
  }),
  undoTask: ({
    calendarDateId,
    checklistId,
    taskName
  }) => HttpClient.get(BOOKING_URL, {
    section_checklist: BOOKINGS_STRING,
    external_table: CALENDAR_DATES,
    external_id: calendarDateId,
    action: BOOKING_CALENDAR_TASK_CHECKLIST_ITEM_ASSIGN_TO_USER,
    section: BOOKINGS_STRING,
    checklist_id: checklistId,
    from: TASK_DONE_UNDO,
    task_name: taskName
  }),
  removeChecklistItemGroup: ({
    groupName
  }) => HttpClient.post(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: BOOKING_CALENDAR_TASK_CHECKLIST_ITEM_GROUP_DELETE,
    section_checklist: BOOKINGS_STRING,
    group_name: groupName
  }),
  removeChecklistItem: ({
    name
  }) => HttpClient.post(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: BOOKING_CALENDAR_TASK_CHECKLIST_ITEM_DELETE,
    section_checklist: BOOKINGS_STRING,
    name
  }),
  updateInvoicePrice: ({
    invoiceLineId,
    price,
  }) => HttpClient.post(MODIFICATION_URL, {
    kVal: invoiceLineId,
    name: PRICE,
    value: price,
    table: INVOICELINES,
  }),
  updateInvoiceText: ({
    invoiceLineId,
    text
  }) => HttpClient.post(MODIFICATION_URL, {
    kVal: invoiceLineId,
    name: TEXT,
    value: text,
    table: INVOICELINES,
  }),
  updateInvoiceModifyRecord: ({
    invoiceLineId,
    due_date,
    text,
  }) => HttpClient.post(MODIFICATION_URL, {
    modify_type: RECORD_STRING,
    table: INVOICELINES,
    kVal: invoiceLineId,
    due_date,
    text: text,
  }),
  updateInvoicePriceText: ({
    invoiceline_id,
    price,
    text
  }) => HttpClient.post(MODIFICATION_URL, {
    modify_type: RECORD_STRING,
    table: INVOICELINES,
    kVal: invoiceline_id,
    price: price,
    text: text
  }),
  updateInvoiceTaxType: ({
    invoiceLineId,
    taxType,
    vatType = 0,
  }) => HttpClient.post(MODIFICATION_URL, {
    modify_type: RECORD_STRING,
    table: INVOICELINES,
    kVal: invoiceLineId,
    vat_type: vatType,
    tax_type_id: taxType
  }),
  findInvoiceLineForm: ({
    calendarDateId
  }) => HttpClient.get(BOOKING_URL, {
    section: BOOKINGS_STRING,
    calendar_date_id: calendarDateId,
    action: CALENDAR_BOOKINGS_DEALS_ADD_INVOICELINES_FORM,
    output: JSON_STRING,
  }),

  findBookingInvoiceProjects: ({
    calendarDateId,
    promoter = 1,
  }) => HttpClient.get(BOOKING_URL, {
    section: BOOKINGS_STRING,
    calendar_date_id: calendarDateId,
    action: BOOKING_DEALS_INVOICE_PROJECTS,
    promoter,
    output: JSON_STRING
  }),
  createInvoice: ({
    calendarDateId,
    invoiceProjectId,
    invoiceLineIds = '[]',
    promoter = 1,
  }) => HttpClient.post(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: BOOKING_DEALS_CREATE_INVOICE,
    calendar_date_id: calendarDateId,
    invoice_project_id: invoiceProjectId,
    invoicelineids: invoiceLineIds,
    promoter: promoter,
  }),
  findPaypalPaymentMsg: ({
    invoiceId
  }) => HttpClient.post(ACCOUNTING_URL, {
    section: INVOICES_STRING,
    action: DISPLAY_PAYPAL_PAYMENT_MSG_MODAL,
    invoice_id: invoiceId
  }),
  findInvoiceEmailDetails: ({
    invoiceId,
    output_media = ''
  }) => HttpClient.post(ACCOUNTING_URL, {
    section: INVOICE_REMAINDER,
    action: EMAIL_INVOICE_DETAILS,
    invoice_id: invoiceId,
    output_media
  }),


  getLoggedUserTasks: () => {
    console.log('mdsir service.');
    return HttpClient.get2(BOOKING_URL, {
      section: BOOKINGS_STRING,
      action: 'booking_tasks_list_current_user',
      section_checklist: 'bookings',
      output: JSON_OUTPUT
    });
  },
  fetchBookingTaskFilterFormData: () => {
    return HttpClient.get(BOOKING_URL, {
      section: BOOKINGS_STRING,
      action: 'booking_tasks_task_list_filter_form'
    });
  },
  fetchBookingTasks: (params) => {
    return HttpClient.get(BOOKING_URL, {
      section: BOOKINGS_STRING,
      action: 'booking_tasks_task_list',
      ...params
    });
  },
  fetchBookingTaskDetails: (task_id) => {
    return HttpClient.get(BOOKING_URL, {
      section: BOOKINGS_STRING,
      action: 'booking_tasks_task_details',
      task_id
    });
  },



  // Add Booking Calls

  findBookingWizardInfo: ({
    bookingDate
  }) => HttpClient.get(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: BOOKING_WIZARD,
    booking_date: bookingDate
  }),

  findCountriesOfCity: ({
    city
  }) => HttpClient.post(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: COUNTRIES_OF_CITY,
    city: city
  }),

  findArtistBookingWizard: ({
    search,
    start_date,
    end_date,
    city,
    country
  }) => HttpClient.post(BOOKING_URL, {
    url: BOOKING_PL,
    section: BOOKINGS_STRING,
    action: BOOKING_WIZARD_SEARCH_ARTIST,
    table_id: ARTIST_TABLE,
    status_id: ARTIST_SEARCH_STATUS,
    search,
    start_date,
    end_date,
    city,
    country,
    output: JSON_STRING
  }),

  findVenueWizard: ({
    city
  }) => HttpClient.post(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: NEXT_BOOKING_WIZARD_STEP_1,
    city: city,
    output: JSON_STRING,
  }),

  searchVenu: ({
    city,
    country,
    search,
    minSearchLength = 3,
  }) => HttpClient.post(BOOKING_URL, {
    url: BOOKING_PL,
    section: BOOKINGS_STRING,
    action: BOOKING_WIZARD_SEARCH_VENUE,
    table_id: VENUE_TABLE,
    status_id: VENUE_SEARCH_STATUS,
    city: city,
    country: country,
    fCharOfSearch: head(search),
    minSearchLength: minSearchLength,
    search: search,
    output: JSON_STRING,
  }),

  findVenueContext: ({
    bookingLocationId = '',
    startDate = '',
    promoterId = 0,
    contactId = 0
  }) => HttpClient.get(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: GET_VENUE_CONTEXT,
    booking_location_id: bookingLocationId,
    start_date: startDate,
    promoter_id: promoterId,
    contact_id: contactId
  }),

  findVenueContextByCalendarDate: ({
    calendarDateId
  }) => HttpClient.get(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: GET_VENUE_CONTEXT,
    calendar_date_id: calendarDateId,
    output: JSON_STRING,
  }),

  modifyBookingLocation: ({
    bookingLocationId,
    name,
    value
  }) => HttpClient.post(MODIFICATION_URL, {
    key: BOOKING_LOCATION_ID,
    kVal: bookingLocationId,
    name: name,
    value: value,
    table: BOOKING_LOCATIONS
  }),

  findVenueContextByCalendarDate: ({
    calendarDateId
  }) => HttpClient.get(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: GET_VENUE_CONTEXT,
    calendar_date_id: calendarDateId
  }),

  findBookingPromoter: ({
    search,
    city,
    country,
    minSearchLength = 3,
    firstCharOfSearch = head(search),
  }) => HttpClient.post(BOOKING_URL, {
    url: BOOKING_PL,
    section: BOOKINGS_STRING,
    action: BOOKING_WIZARD_SEARCH_PROMOTER,
    table_id: PROMOTER_TABLE1,
    status_id: PROMOTER_SEARCH_STATUS,
    fCharOfSearch: firstCharOfSearch,
    city: city,
    country: country,
    minSearchLength: minSearchLength,
    search: search,
    output: JSON_STRING,
  }),

  checkContactIsPromoter: ({
    contactId
  }) => HttpClient.post(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: BOOKING_WIZARD_CHCK_CONTACT_IS_PROMOTER,
    contact_id: contactId
  }),

  verifyContact: ({
    firstName,
    lastName,
    companyName,
    email,
    city,
    country
  }) => HttpClient.post(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: VERIFY_PROMOTER,
    first_name: firstName,
    last_name: lastName,
    company_name: companyName,
    email1: email,
    city: city,
    country: country,
    output: JSON_STRING,
  }),

  linkToPromoter: ({
    promoterId,
    contactId
  }) => HttpClient.post(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: LINK_CONTACT_TO_PROMOTER,
    promoter_id: promoterId,
    contact_id: contactId
  }),

  modifyContact: ({
    contactId,
    name,
    value
  }) => HttpClient.post(MODIFICATION_URL, {
    key: CONTACT_ID,
    kVal: contactId,
    name: name,
    value: value,
    table: CONTACTS,
  }),

  findWizard3: ({
    city
  }) => HttpClient.post(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: NEXT_BOOKING_WIZARD_STEP_3,
    city: city,
    output: JSON_STRING,
  }),

  searchContactBookingWizard: ({
    search
  }) => HttpClient.post(BOOKING_URL, {
    url: BOOKING_PL,
    section: BOOKINGS_STRING,
    action: BOOKING_WIZARD_SEARCH_CONTACT,
    table_id: CONTACT_TABLE,
    status_id: CONTACT_SEARCH_STATUS,
    search: search,
    output: JSON_STRING
  }),

  // insertBooking: ({
  //   notOK,
  //   contact_first_name,
  //   contact_last_name,
  //   contact_phone1,
  //   contact_phone2,
  //   contact_email1,
  //   contact_city,
  //   contact_postalcode,
  //   contact_country,
  //   new_contact,
  //   contact_language,
  //   contact_id_promoter2,
  //   contact_id_promoter,
  //   promoter_name,
  //   promoter_address1,
  //   promoter_city,
  //   promoter_postalcode,
  //   promoter_region,
  //   promoter_country,
  //   promoter_phone1,
  //   promoter_phone2,
  //   promoter_email1,
  //   promoter_vat_no,
  //   promoter_url1,
  //   promoter_language,
  //   venueName,
  //   venueAddress1,
  //   venueCity,
  //   venuePostalcode,
  //   venueCountry,
  //   venuePhone1,
  //   venueEmail,
  //   venueURL1,
  //   venueCapacity,
  //   newVenue,
  //   bookingLocationID,
  //   startDate,
  //   endDate,
  //   city,
  //   country,
  //   dateName,
  //   bookingStatusID,
  //   first_offer_notes,
  //   artists,
  //   section,
  //   action,
  //   userID,
  //   currency,
  //   calendar_date_id,
  // }) => HttpClient.post(BOOKING_URL, {
  //   notOK,
  //   contact_first_name,
  //   contact_last_name,
  //   contact_phone1,
  //   contact_phone2,
  //   contact_email1,
  //   contact_city,
  //   contact_postalcode,
  //   contact_country,
  //   new_contact,
  //   contact_language,
  //   contact_id_promoter2,
  //   contact_id_promoter,
  //   promoter_name,
  //   promoter_address1,
  //   promoter_city,
  //   promoter_postalcode,
  //   promoter_region,
  //   promoter_country,
  //   promoter_phone1,
  //   promoter_phone2,
  //   promoter_email1,
  //   promoter_vat_no,
  //   promoter_url1,
  //   promoter_language,
  //   venueName,
  //   venueAddress1,
  //   venueCity,
  //   venuePostalcode,
  //   venueCountry,
  //   venuePhone1,
  //   venueEmail,
  //   venueURL1,
  //   venueCapacity,
  //   newVenue,
  //   bookingLocationID,
  //   startDate,
  //   endDate,
  //   city,
  //   country,
  //   dateName,
  //   bookingStatusID,
  //   first_offer_notes,
  //   artists,
  //   section,
  //   action,
  //   userID,
  //   currency,
  //   calendar_date_id,
  // }),
  insertBooking: (bookingPostData) => HttpClient.post(BOOKING_URL, bookingPostData),

  requestFormMail: () => HttpClient.get(SETTINGS_URL, {
    section: TEMPLATES_STRING,
    template_key: REQUEST_FORM_MAIL,
    output: JSON_STRING
  }),

  requestFormMailUrl: ({
    templateId,
    subject,
  }) => HttpClient.post(SETTINGS_URL, {
    request_link: BOOKING_REQUEST_HOSTED_URL(clientName),
    template_key: REQUEST_FORM_MAIL,
    action: RENDER_STRING,
    section: TEMPLATES_STRING,
    template_id: templateId,
    subject,
  }),

  findExternalCalendarDates: ({
    month
  }) => HttpClient.post(BOOKING_URL, {
    section: BOOKINGS_STRING,
    action: MONTHLY_CALENDAR_DATES,
    month
  }),

  findBookingCalendarBookings: ({
    month = '2020-04'
  }) => HttpClient.post(BOOKING_URL, {
    section: 'bookings',
    action: 'monthly_calendar_summary',
    month
  }),

  findAvailableArtists: ({
    start_date
  }) => HttpClient.post(BOOKING_URL, {
    section: 'bookings',
    action: 'available_artists',
    start_date,
    end_date: start_date,
  }),



  has_permission: (calendar_date_id) => HttpClient.get2(BOOKING_URL, {
    section: 'bookings',
    action: 'has_permission',
    calendar_date_id,
  }),


  ...overviewService,
  ...moneyDetailsService,
  ...bookingDocumentService,
  ...eventDetailsService,
  ...customChecklistService,
  ...travelDetailsService,
  ...localDetailsService,
  ...bookingRequestsService,
  ...bookingTemplatesService,
  ...ArtistService,
  ...bookingPromotersService,
  ...bookingReportsService,
};
// booking_month=201806&artist=%2A&status=%5B%5D&staff_id=&txt=&status_c=&status_r=&status_l=&status_t=&status_i=&section=booking&action=booking_list



const modifyCaledarArtistKeys = ['stage_name', 'soundcheck', 'performance_type', 'performance_time', 'performance_time_contract', 'artist_before', 'artist_after', 'schedule_notes', 'confirmed_flag', 'date_hotel_start', 'date_hotel_end', 'single_rooms', 'double_rooms', 'suites', 'travel_qty', 'guestlist', 'guestlist_tickets', 'playlist_id', 'travel_options', 'travel_option2', 'hotel_class', 'travel_class', 'techrider', 'catering', 'hotel_class2', 'travel_class2', 'techrider2', 'catering2'];
